import type { Invoice } from "@nlc/shared-types";

import { TableBody } from "react-aria-components";

import { Cell, Column, Row, Table, TableHeader } from "@/components/table";

import { formatInvoiceDate, formatInvoiceTotal } from "../utils/invoice-format";
import { InvoiceActions } from "./InvoiceActions";
import { InvoiceStatusBadge } from "./InvoiceStatusBadge";

interface InvoicesTableProps {
  invoices: Invoice[];
  onCopyLink: (invoice: Invoice) => void;
  onIssueCredit?: (invoice: Invoice) => void;
}

export function InvoicesTable({
  invoices,
  onCopyLink,
  onIssueCredit,
}: InvoicesTableProps) {
  return (
    <Table aria-label="Invoices">
      <TableHeader className="border-b border-b-border-secondary">
        <Column isRowHeader minWidth={110} width="130fr">
          Total
        </Column>
        <Column minWidth={120} width="139fr">
          Date
        </Column>
        <Column minWidth={240} width="438fr">
          Description
        </Column>
        <Column minWidth={230} width="248fr">
          Invoice ID
        </Column>
        <Column minWidth={100} width="161fr">
          Status
        </Column>
        <Column minWidth={100} width="132fr">
          Action
        </Column>
      </TableHeader>

      <TableBody items={invoices}>
        {(invoice) => (
          <Row id={invoice.id}>
            <Cell>
              <div className="py-xl font-semibold text-text-primary whitespace-nowrap">
                {formatInvoiceTotal(invoice.total, invoice.currency)}
              </div>
            </Cell>

            <Cell>
              <span className="whitespace-nowrap">
                {formatInvoiceDate(invoice.date)}
              </span>
            </Cell>

            <Cell>{invoice.description}</Cell>

            <Cell>
              <span className="whitespace-nowrap">{invoice.id}</span>
            </Cell>

            <Cell>
              <InvoiceStatusBadge status={invoice.status} />
            </Cell>

            <Cell>
              <InvoiceActions
                invoice={invoice}
                onCopyLink={onCopyLink}
                onIssueCredit={onIssueCredit}
              />
            </Cell>
          </Row>
        )}
      </TableBody>
    </Table>
  );
}
